export default defineNuxtRouteMiddleware((to, from) => {
  // console.log("hash-suppress", to, from);

  // ログインリダイレクトで戻ってきた時に hash の解釈で /auth/msal から / への遷移が発生しないようにする
  if (from.path === "/auth/msal"
    && to.path === "/"
    && to.hash === from.hash
    // hash はそれなりの長さがある (state, client_info, code とダイジェストを必ず含む) 実績値だと 1120 文字の例があった
    && to.hash.length > 128
  ) {
    return abortNavigation();
  }
});
